module.exports = __webpack_public_path__ + "static/img/wg_header.8960807e.png";